import { configureStore } from "@reduxjs/toolkit";
import * as reducers from "./reducers";
import thunk from "redux-thunk";

export default configureStore({
  middleware: [thunk],
  reducer: { ...reducers },
});
